import { render, staticRenderFns } from "./CardPackMessage.vue?vue&type=template&id=d78f98f6"
import script from "./CardPackMessage.vue?vue&type=script&lang=js"
export * from "./CardPackMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports